import React from 'react';
import type { FallbackProps } from 'react-error-boundary';

const ErrorFallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => (
  <div style={{
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    padding: 40,
    textAlign: 'center',
  }}>
    <div style={{ fontSize: 32, lineHeight: 1 }}>⚠️</div>
    <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text)' }}>Что-то пошло не так</div>
    <div style={{ fontSize: 13, color: 'var(--text2)', maxWidth: 420, lineHeight: 1.5 }}>
      {error?.message || 'Произошла непредвиденная ошибка'}
    </div>
    <button
      onClick={resetErrorBoundary}
      style={{
        padding: '8px 20px',
        background: 'var(--og)',
        border: 'none',
        borderRadius: 'var(--r-sm)',
        color: '#fff',
        fontFamily: 'Manrope, sans-serif',
        fontSize: 14,
        fontWeight: 700,
        cursor: 'pointer',
      }}
    >
      Попробовать снова
    </button>
  </div>
);

export { ErrorFallback };
